module.exports = __webpack_public_path__ + "static/js/0.6da9afd0.chunk.worker.js"